import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Loader2 } from "lucide-react";

const LOST_REASONS = [
  { key: "price",          label: "Price" },
  { key: "timing",         label: "Timing/availability" },
  { key: "other_provider", label: "Chose another provider" },
  { key: "not_suitable",   label: "Not suitable/referred elsewhere" },
  { key: "no_response",    label: "No response" },
  { key: "other",          label: "Other" },
];

export function LostReasonDialog({ name, busy, onClose, onSave }) {
  const [reason, setReason] = useState("");
  const [note, setNote] = useState("");
  const noteRequired = reason === "other";
  const canSave = reason && (!noteRequired || note.trim());

  return (
    <Dialog open onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md" data-testid="lost-reason-dialog">
        <DialogHeader>
          <DialogTitle>Why is {name || "this person"} not proceeding?</DialogTitle>
          <DialogDescription className="text-xs">
            Recorded on all their enquiries and counted in Analytics → Why we lose people.
          </DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-1.5" role="radiogroup">
          {LOST_REASONS.map((r) => (
            <button
              key={r.key}
              type="button"
              role="radio"
              aria-checked={reason === r.key}
              onClick={() => setReason(r.key)}
              className={`text-left text-xs px-2.5 py-2 rounded-md border transition-colors ${reason === r.key ? "bg-zinc-950 text-white border-zinc-950" : "bg-white text-zinc-800 border-zinc-300 hover:border-zinc-500"}`}
              data-testid={`lost-reason-${r.key}`}
            >{r.label}</button>
          ))}
        </div>
        <div>
          <Label className="text-2xs">
            Note {noteRequired ? <span className="text-red-600">(required for Other)</span> : <span className="text-zinc-400">(optional)</span>}
          </Label>
          <Textarea
            rows={2}
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="e.g. Went with a clinic closer to home"
            data-testid="lost-reason-note"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose} data-testid="lost-reason-cancel">Cancel</Button>
          <Button
            onClick={() => onSave(reason, note.trim() || null)}
            disabled={!canSave || busy}
            className="bg-zinc-950 text-white"
            data-testid="lost-reason-save"
          >
            {busy && <Loader2 className="h-4 w-4 mr-1 animate-spin" />} Mark as Lost
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
